import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

// material-ui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// assets
import { ClipboardText } from 'iconsax-reactjs';

// ==============================|| HEADER CONTENT - MY TASKS ||============================== //

// Mobile-only quick link to the seat's My Tasks queue (/work-orders/tasks) — on desktop the same
// page is reachable from the sidebar, but the sidebar collapses on mobile. Shown to the seats the
// MENU-01 matrix grants the entry (FLEET_OPERATOR, FLEET_MANAGER, FINANCIAL_MANAGER).
// MENU-02 (VEK-47) — drawn as a header tile like the notification bell beside it (same light
// secondary background, icon/text colour, 44px height and radius), keeping its visible label.
export default function MyTasksButton() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Button
        variant="text"
        color="secondary"
        startIcon={<ClipboardText variant="Bold" size={20} />}
        onClick={() => navigate('/work-orders/tasks')}
        sx={(theme) => ({
          height: theme.spacing(5.5),
          px: 1.5,
          borderRadius: 1,
          whiteSpace: 'nowrap',
          color: 'secondary.main',
          bgcolor: 'secondary.100',
          '&:hover': { bgcolor: 'secondary.200' },
          ...theme.applyStyles('dark', { bgcolor: 'background.default', '&:hover': { bgcolor: 'background.paper' } })
        })}
      >
        {t('menu.workOrderTasks', { defaultValue: 'My Tasks' })}
      </Button>
    </Box>
  );
}
